<template>
  <div id="auser">
    <el-dropdown @command="handleDropDown" class="unav_text" trigger="click">
      <span>
        <i class="el-icon-3d-profile1"></i>
        <span class="dp_title">{{uTitle}}</span>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="name in $gf.factoryNames()" :key="name">
          {{name}}
        </el-dropdown-item>
        <el-dropdown-item command="cases">
          <i class="el-icon-3d-yachiteeth1"></i>
          {{$t("cmsg.cases")}}
        </el-dropdown-item>
        <el-dropdown-item command="chpwd">
          <i class="el-icon-3d-password"></i>
          {{$t("cmsg.chPwd")}}
        </el-dropdown-item>
        <el-dropdown-item command="logout">
          <i class="el-icon-3d-logout"></i>
          {{$t('cmsg.logout')}}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog
      :title="$t('cmsg.chPwd')"
      :visible.sync="changePwdForm.visible"
      @close="resetChangePwdForm"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :model="changePwdForm.field"
        status-icon
        :validate-on-rule-change="false"
        label-width="130px;"
        ref="changePwdForm"
        :show-message="false"
      >
        <el-form-item
          required
          prop="password"
          :label="$t('cmsg.newPwd')"
          :error="changePwdForm.errors.password"
        >
          <el-input
            v-model="changePwdForm.field.password"
            type="password"
            :placeholder="$t('cmsg.newPwd')"
            @keyup.enter.native1="onSubmit"
          ></el-input>
        </el-form-item>
        <el-form-item
          required
          prop="npassword"
          :label="$t('cmsg.newPwdAgain')"
          :error="changePwdForm.errors.npassword"
        >
          <el-input
            v-model="changePwdForm.field.npassword"
            type="password"
            :placeholder="$t('cmsg.newPwdAgain')"
            @keyup.enter.native1="onSubmit"
          ></el-input>
        </el-form-item>
      </el-form>
      <!-- <p v-if="changePwdForm.err">{{changePwdForm.err}}</p> -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetChangePwdForm">{{$t('cmsg.cancel')}}</el-button>
        <el-button
          type="primary"
          @click="submitChangePwdForm"
          :loading="changePwdForm.loading"
        >{{$t('cmsg.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
export default {
  name: "auser",
  data() {
    return {
      uTitle: Cookies.get("uTitle"),
      changePwdForm: {
        err: "",
        visible: false,
        loading: false,
        errors: {
          npassword: null,
          password: null
        },
        field: {
          password: "",
          npassword: ""
        }
      }
    };
  },
  methods: {
    submitChangePwdForm() {
      this.changePwdForm.err = "";
      // var vueObj = this;
      if (
        this.changePwdForm.field.password !== this.changePwdForm.field.npassword
      ) {
        this.changePwdForm.err = this.$t("cmsg.twoPwdMatch");
        this.changePwdForm.errors["password"] = this.$t("cmsg.twoPwdMatch");
        this.changePwdForm.errors["npassword"] = this.$t("cmsg.twoPwdMatch");
        this.$message({
          type: "error",
          message: this.$t("cmsg.twoPwdMatch")
        });
        return false;
      }
      this.$refs["changePwdForm"].validate(valid => {
        if (valid) {
          this.changePwdForm.loading = true;
          this.$axios
            .post(
              `/api/u/auth/user/cp`,
              {
                uId: Cookies.get("user_id"),
                newPasswd: this.changePwdForm.field.password
              },
              {
                json: true,
                validateStatus: function(status) {
                  return status >= 200 && status < 404; // default
                }
              }
            )
            .then(res => {
              // console.log("res: ", res.data.result.perms);
              if (res.data && res.data.status !== "success") {
                this.changePwdForm.err = res.data.result;
                var ermsg = {};
                try {
                ermsg = JSON.parse(res.data.result);
                }catch(e){
                  console.log(e);
                }
                Object.keys(ermsg).map((erk, i) => {
                  this.changePwdForm.errors[erk] = ermsg[erk];
                });
                this.changePwdForm.loading = false;
              } else {
                this.$message({
                  type: "success",
                  message: this.$t("cmsg.successAction")
                });
                var t = this;
                setTimeout(function() {
                  t.logout();
                }, 3000);
              }
            })
            .catch(err => {
              console.log("err: ", err);
              this.changePwdForm.err = this.$t("cmsg.mting");
              this.changePwdForm.loading = false;
            });
        } else {
          this.changePwdForm.loading = false;
          return false;
        }
      });
    },
    resetChangePwdForm() {
      this.changePwdForm = {
        err: "",
        visible: false,
        loading: false,
        errors: {
          npassword: null,
          password: null
        },
        field: {
          password: "",
          npassword: ""
        }
      };
    },
    handleDropDown(v) {
      console.log(v);
      var tLang = Cookies.get("lang") || "cn";
      switch (v) {
        case "logout":
          this.logout();
          break;
        case "chpwd":
          this.changePwdForm.visible = true;
          break;
        case "cases":
          window.location = this.$router.resolve({name: "cases"}).href;
          // this.$redirect({name:"cases"});
      }
    },
    logout() {
      Cookies.remove("token");
      Cookies.remove("factories");
      Cookies.remove("factory_names");
      Cookies.remove("admin_factories");
      Cookies.remove("user_id");
      Cookies.remove("uTitle");
      //   window.location = this.$router.resolve({ name: "cnLogin" }).href;
      this.$redirect({ name: "login" });
    }
  },
  mounted() {
    // this.lang = Cookies.get("lang") || "cn";
  }
};
</script>
<style lang="scss">
#auser {
  display: inline;
  .unav_text {
    color: #4b91d1;
    // margin-left: 15px;
    // border: 1px solid #4b91d1;
    // border-right: 1px solid #4b91d1;
    padding: 5px 10px;
    cursor: pointer;
    span {
      .dp_title {
        @media only screen and (max-width: 1020px) {
          display: none;
        }
      }
    }
  }
  .el-dialog__wrapper {
    text-align: left;
    .el-dialog {
      @media only screen and (max-width: 1020px) {
        width: 95vw;
      }
    }
  }
}
</style>
